/**
 * BOM lines API calls.
 */

import client, { fetchAllPages } from './client';

export async function fetchBomLines(jobId) {
  // All pages — BomTab renders every line + CostingTab totals across
  // all lines. Prior code passed page_size=500 which covers Kevin's
  // realistic scale, but fetchAllPages is one call away and keeps
  // this list on the same all-pages contract as sibling helpers
  // (fetchVendorQuotes, fetchRfqs, fetchPurchaseOrders).
  return fetchAllPages('/jobs/bom-lines/', { job: jobId });
}

export async function createBomLine(payload) {
  const { data } = await client.post('/jobs/bom-lines/', payload);
  return data.data;
}

export async function updateBomLine(lineId, payload) {
  const { data } = await client.patch(`/jobs/bom-lines/${lineId}/`, payload);
  return data.data;
}

export async function deleteBomLine(lineId) {
  await client.delete(`/jobs/bom-lines/${lineId}/`);
}

export async function exportBomTrulinx(jobId) {
  const { data } = await client.get(`/jobs/${jobId}/bom/export-trulinx/`, {
    responseType: 'blob',
  });
  return data;
}
